import React, { useState, useEffect } from 'react';
import {
    Table,
    Dropdown,
    Row,
    Col,
    Form,
    Button,
    InputGroup,
    Spinner,
} from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import { toast } from 'react-toastify';
import { ReactComponent as ReactMoreIcon } from '../../../../assets/icons/more.svg';
import { StyledPageTitle } from '../../../../styles/pageTitle';
import { StyledTh } from '../../PointData/styles';
import PaymentHttpService from '../../../../services/http/payment-http';
import PaymentMethodsModal from './PaymentMethodsModal';
import PaymentMethodHttpService from '../../../../services/http/payment-method.http';

export default function PaymentMethodsData() {
    const [selectedMethod, setSelectedMethod] = useState({});
    const [term, setTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState<any>([]);
    const [isEdit, setIsEdit] = useState(false);
    
    const getPaymentMethods = async () => {
        try {
            const response = await PaymentHttpService.listPaymentMethods();
            setPaymentMethods(response.data.data);
        } catch (error) {
            setPaymentMethods([]);
        }
    };
    
    const deleteMethod = async (rate: any) => {
        setLoading(true);
        try {
            await PaymentMethodHttpService.deletePaymentMethod(rate.id);
            getPaymentMethods();
            toast.success('Metodo de pagamento excluído.');
        } catch (error) {
            const err = error as any;
            toast.error(err.message);
        }
        setLoading(false);
    };


    useEffect(() => {
        getPaymentMethods();
    }, []);

    return (
        <>
            <PaymentMethodsModal
                show={showModal}
                isOpen={setShowModal}
                update={getPaymentMethods}
                selectedMethod={selectedMethod}
                isEdit={isEdit}
                onHide={() => {
                    setSelectedMethod({});
                    setShowModal(false);
                }}
            />
            <Row>
                <Col>
                    <StyledPageTitle className="mt-2"> Meios de Pagamento</StyledPageTitle>
                </Col>
                <Col>
                    <Button
                        className="float-right w-25 m-2"
                        onClick={() => {
                            setIsEdit(false);
                            setShowModal(true);
                        }}
                    >
                        Novo método de pagamento
                    </Button>
                </Col>
            </Row>
            <Row>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <i className="fas fa-search" />
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        type="text"
                        value={term}
                        onChange={(event) => setTerm(event.target.value)}
                        placeholder="Digite aqui o que procura..."
                    />
                </InputGroup>
            </Row>
            <Row>
                <Table bordered hover size="sm" className="text-center">
                    <thead>
                        <tr>
                            <StyledTh>Nome do meio de pagamento</StyledTh>
                            <StyledTh>Quantidade máxima de Parcelas</StyledTh>
                            <StyledTh>Parcelamento padrão</StyledTh>
                            <StyledTh />
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan={4}><Spinner animation="border" /></td></tr>
                        ) : (
                            paymentMethods.filter((item: any) =>
                                item.name?.toLowerCase().includes(term.toLowerCase()) ||
                                String(item.installment).includes(term) ||
                                String(item.percentage).includes(term)
                            ).map((item: any, index: any) => (
                                <tr key={index}>
                                    <td style={{ padding: 10 }}>
                                        <Highlighter
                                            autoEscape
                                            highlightClassName="highlight-term"
                                            searchWords={[term]}
                                            textToHighlight={item.name || ''}
                                        />
                                    </td>
                                    <td>{item.maxInstallments}</td>
                                    <td>{item.defaultInstallment}</td>                                    
                                    <td>
                                        <Dropdown key="left">
                                            <Dropdown.Toggle
                                                bsPrefix="nexen"
                                                className="mt-n3 mb-n3"
                                                as={Button}
                                                variant="text"
                                            >
                                                <ReactMoreIcon
                                                    fill="#bdbdbd"
                                                    width="10"
                                                    height="20"
                                                />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setSelectedMethod(item);
                                                        setShowModal(true);
                                                        setIsEdit(true);
                                                    }}
                                                >
                                                    Editar
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        deleteMethod(item);
                                                    }}
                                                >
                                                    Remover
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </Row>
            {paymentMethods.length === 0 && (
                <Col md={12} className="text-center">
                    <strong style={{ color: '#adadad' }}>
                        Sem itens para carregar
                    </strong>
                </Col>
            )}
        </>
    );
};

